import PropTypes from 'prop-types';
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {Icon} from 'semantic-ui-react';

import {getMatomoInstanceLink} from 'state/selectors';

import styles from './MatomoLink.module.scss';

const MatomoLink = ({siteId}) => {
  const matomoInstanceLink = useSelector(getMatomoInstanceLink);
  const generateMatomoLink = useCallback(
    siteId => {
      const url = new URL('index.php', matomoInstanceLink);
      url.search = new URLSearchParams({
        module: 'CoreHome',
        action: 'index',
        idSite: siteId,
        date: 'yesterday',
        period: 'day',
      });
      return url.toString();
    },
    [matomoInstanceLink]
  );

  return (
    <a
      className={styles.MatomoLink}
      href={generateMatomoLink(siteId)}
      target="_blank"
      rel="noreferrer"
    >
      View Matomo Analytics <Icon name="external alternate" size="small" />
    </a>
  );
};

MatomoLink.propTypes = {
  siteId: PropTypes.number.isRequired,
};

export default MatomoLink;
